import { ClassNames } from "@emotion/react";
import Image from "next/image";
import React from "react";
export const MaskedImage = ({ alt, id, path, src, title, viewBox }) => (React.createElement(React.Fragment, null,
    React.createElement("svg", { style: { height: 0, width: 0 }, viewBox: viewBox, xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("defs", null,
            React.createElement("clipPath", { clipPathUnits: "objectBoundingBox", id: id }, path))),
    React.createElement(ClassNames, null, ({ css, cx }) => (React.createElement(Image, { alt: alt, className: css({ clipPath: `url(#${id})` }), placeholder: "blur", src: src, title: title, style: { width: "100%", height: "auto" } })))));
//# sourceMappingURL=masked-image.js.map